import type { FC, ReactNode } from 'react';
import { useEffect, useContext, memo } from 'react';

import { EditorContextPanelContext } from './EditorContextPanelContext.ts';

type Props = {
	itemName: string;
	children: ReactNode;
	closeSelf: () => void;
	hasPadding?: boolean;
	customWidth?: number;
};

/**
 * @deprecated Do not use - prefer rendering directly inside EditorContextPanelView.
 * The design of this component is fundamentally flawed, causing poor performance and bugs like https://hello.jira.atlassian.cloud/browse/DISCO-4183
 */
export const EditorContextPanelItem: FC<Props> = memo(
	({ itemName, children: component, closeSelf, hasPadding = true, customWidth }) => {
		const { setItem, removeItem } = useContext(EditorContextPanelContext);

		// remove the item on unmount
		useEffect(() => {
			return () => {
				removeItem(itemName);
			};
		}, [itemName, removeItem]);

		useEffect(() => {
			if (component) {
				setItem({
					itemName,
					component,
					close: closeSelf,
					hasPadding,
					customWidth,
				});
			} else {
				removeItem(itemName);
			}
		}, [component, itemName, setItem, removeItem, closeSelf, hasPadding, customWidth]);

		return null;
	},
);
